// System
import { Button, Stack, Typography } from '@mui/material';
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { useMinesRoundsTable } from '@Modal/hooks/rounds/useMinesRoundsTable';

export const MinesRoundsTitle: React.FC = () => {
  const { roundTableFilters, clearRoundTableFiltersHandler } = useMinesRoundsTable();
  const objectVals = Object.values(roundTableFilters);
  const disabled = objectVals.length === 0 || objectVals.every((val) => val === undefined);

  return (
    <AtLocator type="container" name="MinesRoundsTitle">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ paddingBottom: 2 }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h3">Mines Rounds</Typography>
        </Stack>
        <AtLocator type="button" name="clearFilters">
          <Button
            size="large"
            variant="contained"
            disabled={disabled}
            onClick={clearRoundTableFiltersHandler}
          >
            Clear filters
          </Button>
        </AtLocator>
      </Stack>
    </AtLocator>
  );
};
